/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { introductionInquiryControllerCreate } from '../fn/introduction-inquiry/introduction-inquiry-controller-create';
import { IntroductionInquiryControllerCreate$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-create';
import { introductionInquiryControllerDelete } from '../fn/introduction-inquiry/introduction-inquiry-controller-delete';
import { IntroductionInquiryControllerDelete$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-delete';
import { introductionInquiryControllerFindAll } from '../fn/introduction-inquiry/introduction-inquiry-controller-find-all';
import { IntroductionInquiryControllerFindAll$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-find-all';
import { introductionInquiryControllerFindById } from '../fn/introduction-inquiry/introduction-inquiry-controller-find-by-id';
import { IntroductionInquiryControllerFindById$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-find-by-id';
import { introductionInquiryControllerSearchCursor } from '../fn/introduction-inquiry/introduction-inquiry-controller-search-cursor';
import { IntroductionInquiryControllerSearchCursor$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-search-cursor';
import { introductionInquiryControllerSearchOffset } from '../fn/introduction-inquiry/introduction-inquiry-controller-search-offset';
import { IntroductionInquiryControllerSearchOffset$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-search-offset';
import { introductionInquiryControllerUpdate } from '../fn/introduction-inquiry/introduction-inquiry-controller-update';
import { IntroductionInquiryControllerUpdate$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-update';
import { introductionInquiryControllerUpdateStatus } from '../fn/introduction-inquiry/introduction-inquiry-controller-update-status';
import { IntroductionInquiryControllerUpdateStatus$Params } from '../fn/introduction-inquiry/introduction-inquiry-controller-update-status';
import { IntroductionInquiryDto } from '../models/introduction-inquiry-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class IntroductionInquiryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `introductionInquiryControllerFindAll()` */
  static readonly IntroductionInquiryControllerFindAllPath = '/api/introduction-inquiry';

  /**
   * 도입문의 전체 조회.
   *
   * 도입문의 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerFindAll$Response(params?: IntroductionInquiryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IntroductionInquiryDto>>> {
    return introductionInquiryControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 전체 조회.
   *
   * 도입문의 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerFindAll(params?: IntroductionInquiryControllerFindAll$Params, context?: HttpContext): Observable<Array<IntroductionInquiryDto>> {
    return this.introductionInquiryControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<IntroductionInquiryDto>>): Array<IntroductionInquiryDto> => r.body)
    );
  }

  /** Path part for operation `introductionInquiryControllerCreate()` */
  static readonly IntroductionInquiryControllerCreatePath = '/api/introduction-inquiry';

  /**
   * 도입문의 생성.
   *
   * 도입문의를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  introductionInquiryControllerCreate$Response(params: IntroductionInquiryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
    return introductionInquiryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 생성.
   *
   * 도입문의를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  introductionInquiryControllerCreate(params: IntroductionInquiryControllerCreate$Params, context?: HttpContext): Observable<IntroductionInquiryDto> {
    return this.introductionInquiryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntroductionInquiryDto>): IntroductionInquiryDto => r.body)
    );
  }

  /** Path part for operation `introductionInquiryControllerSearchOffset()` */
  static readonly IntroductionInquiryControllerSearchOffsetPath = '/api/introduction-inquiry/search/offset';

  /**
   * 도입문의 오프셋 기반 조회.
   *
   * 도입문의를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerSearchOffset$Response(params: IntroductionInquiryControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return introductionInquiryControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 오프셋 기반 조회.
   *
   * 도입문의를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerSearchOffset(params: IntroductionInquiryControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.introductionInquiryControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `introductionInquiryControllerSearchCursor()` */
  static readonly IntroductionInquiryControllerSearchCursorPath = '/api/introduction-inquiry/search/cursor';

  /**
   * 도입문의 커서 기반 조회.
   *
   * 도입문의를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerSearchCursor$Response(params: IntroductionInquiryControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return introductionInquiryControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 커서 기반 조회.
   *
   * 도입문의를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerSearchCursor(params: IntroductionInquiryControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.introductionInquiryControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `introductionInquiryControllerFindById()` */
  static readonly IntroductionInquiryControllerFindByIdPath = '/api/introduction-inquiry/{id}';

  /**
   * 도입문의 ID 기반 조회.
   *
   * 도입문의를 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerFindById$Response(params: IntroductionInquiryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
    return introductionInquiryControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 ID 기반 조회.
   *
   * 도입문의를 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerFindById(params: IntroductionInquiryControllerFindById$Params, context?: HttpContext): Observable<IntroductionInquiryDto> {
    return this.introductionInquiryControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntroductionInquiryDto>): IntroductionInquiryDto => r.body)
    );
  }

  /** Path part for operation `introductionInquiryControllerDelete()` */
  static readonly IntroductionInquiryControllerDeletePath = '/api/introduction-inquiry/{id}';

  /**
   * 도입문의 삭제.
   *
   * 도입문의를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerDelete$Response(params: IntroductionInquiryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
    return introductionInquiryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 삭제.
   *
   * 도입문의를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  introductionInquiryControllerDelete(params: IntroductionInquiryControllerDelete$Params, context?: HttpContext): Observable<IntroductionInquiryDto> {
    return this.introductionInquiryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntroductionInquiryDto>): IntroductionInquiryDto => r.body)
    );
  }

  /** Path part for operation `introductionInquiryControllerUpdate()` */
  static readonly IntroductionInquiryControllerUpdatePath = '/api/introduction-inquiry/{id}';

  /**
   * 도입문의 수정.
   *
   * 도입문의를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  introductionInquiryControllerUpdate$Response(params: IntroductionInquiryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
    return introductionInquiryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 수정.
   *
   * 도입문의를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  introductionInquiryControllerUpdate(params: IntroductionInquiryControllerUpdate$Params, context?: HttpContext): Observable<IntroductionInquiryDto> {
    return this.introductionInquiryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntroductionInquiryDto>): IntroductionInquiryDto => r.body)
    );
  }

  /** Path part for operation `introductionInquiryControllerUpdateStatus()` */
  static readonly IntroductionInquiryControllerUpdateStatusPath = '/api/introduction-inquiry/{id}/status';

  /**
   * 도입문의 상태 변경.
   *
   * 도입문의 상태를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `introductionInquiryControllerUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  introductionInquiryControllerUpdateStatus$Response(params: IntroductionInquiryControllerUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
    return introductionInquiryControllerUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * 도입문의 상태 변경.
   *
   * 도입문의 상태를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `introductionInquiryControllerUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  introductionInquiryControllerUpdateStatus(params: IntroductionInquiryControllerUpdateStatus$Params, context?: HttpContext): Observable<IntroductionInquiryDto> {
    return this.introductionInquiryControllerUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<IntroductionInquiryDto>): IntroductionInquiryDto => r.body)
    );
  }

}
